/* eslint-disable */
import PropTypes from 'prop-types';
import FormDialog from '../../../Components/Modal/modal.js';
import alertIcon from '../../../Assets/images/svg/alert_icon.svg';
import './receivedRequest.scss';
import CommonTextField from '../../../Components/TextField/textField.js';

const ActionConfirmationDialog = ({
  open,
  title,
  description,
  button2Text,
  showCommentBox = true,
  onCancel,
  handleApproveOrReject,
  setComments,
  comments,
}) => {
  return (
    <FormDialog
      open={open}
      title={title}
      dialogCss="tech-session-dialog-message"
      dialogPaperCss="action-confirmation-paper"
      width={360}
      height={260}
      dialogBodycontent={
        <div className="tech-session-dialog-body-text">
          <div className="tech-session-icon-text-wrapper">
            <div className="tech-session-dialog-alert-icon">
              <img
                className="tech-session-icon-image"
                src={alertIcon}
                alt="alert"
              />
            </div>
            <div className="tech-session-dialog-message-text">
              {description}
            </div>
          </div>
          {showCommentBox && (
            <CommonTextField
              label={''}
              placeholder={'Comment...'}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              variant="outlined"
              textCss="tech-session-comment-text-field"
              autoFocus={false}
              size="small"
              id="tech_session_comment"
              multiline={true}
              rows={2}
            />
          )}
        </div>
      }
      handleClose={onCancel}
      button1="Cancel"
      cancelButtonId="cancel-action"
      button1Action={onCancel}
      button2={button2Text}
      onClose={onCancel}
      button2Action={handleApproveOrReject}
      dialogButtonsClass="dialog-actions-row"
    />
  );
};

ActionConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  button2Text: PropTypes.string.isRequired,
  showCheckbox: PropTypes.bool,
  checkbox: PropTypes.bool,
  showCommentBox: PropTypes.bool,
  onCancel: PropTypes.func,
  onCheckboxChange: PropTypes.func,
  handleApproveOrReject: PropTypes.func.isRequired,
  setComments: PropTypes.func,
  comments: PropTypes.string,
};

export default ActionConfirmationDialog;
